import { useState } from "react";
import Button from "../../components/button";
import Field from "../../components/field";
import Modal from "../../components/modal";

const WeekEditor = (props: any) => {
  const [week, setWeek] = useState<string>();
  
  const weekChange = (e: any) => {
    let weekAbs = e.target.value ? Math.abs(e.target.value).toString() : '';
    setWeek(weekAbs);
  };

  const weekSubmit = () => {
    props.onSubmit(week, "weeks");
    props.onClose();
  };
  return (
    <Modal title="Availability" size="xsmall" onClose={props.onClose}>
      <div className="form-group">
      <div className="lablel">
        In 
        <div className="weekInput">
        <Field
          type="number"
          id="years"
          name="weeks"
          value={week}
          placeholder=""
          size="small"
          maxLength={2}
          onChange={(e: any) => weekChange(e)}
        />{" "}
        </div>
        weeks after I get the offer
        </div>
        </div>
        <div className="popupAction">
          <Button variant="secondary" onClick={props.onClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={weekSubmit}>
            Save
          </Button>
        </div>
    
    </Modal>
  );
};
export default WeekEditor;
